// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2Q8LK","header":"ReportDetails_header__M_iUN","title":"ReportDetails_title__2dtVM","left":"ReportDetails_left__9Ms2k"};